import { render, staticRenderFns } from "./ReplyExistingParentingArrangements.vue?vue&type=template&id=a0ab0bbe"
import script from "./ReplyExistingParentingArrangements.vue?vue&type=script&lang=ts"
export * from "./ReplyExistingParentingArrangements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports